module.exports = __webpack_public_path__ + "img/logo-europassistance.b187cc05.svg";